import Vue from "vue";
import PaymentHistory from "./PaymentHistory.vue";

export function load() {
  const selector = "PaymentHistory-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(PaymentHistory, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
